import React, { useCallback, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';
import ContentPageLayout from 'UI/components/templates/ContentPageLayout';
import { backNavigateListConfig } from 'UI/constants/config';
import { PageTitles } from 'UI/constants/defaults';
import { Endpoints } from 'UI/constants/endpoints';

import FeeAgreementsLoader from './FeeAgreementsLoader';

const TYPE_TITLE = {
  Weekly: 'Weekly',
  Yearly: 'Yearly'
};

const defaultElementIndex = 0;

export const AutocompleteForView = ({ viewType, onSelect }) => {
  return (
    <AutocompleteSelect
      placeholder="View"
      value={viewType.value}
      options={[{ title: TYPE_TITLE.Yearly }, { title: TYPE_TITLE.Weekly }]}
      onSelect={onSelect}
      disableClearable
    />
  );
};

export const AutocompleteByYear = ({ year, onSelect, onOptionsLoaded }) => (
  <AutocompleteSelect
    value={year}
    name="weekFilter"
    placeholder="Year"
    onSelect={onSelect}
    onOptionsLoaded={onOptionsLoaded}
    url={Endpoints.FeeAgreementDashboardYears}
    disableClearable
  />
);

export const AutocompleteByWeek = ({ week, year, onSelect, onOptionsLoaded }) => (
  <AutocompleteSelect
    value={week}
    name="weekFilter"
    placeholder="Week"
    onSelect={onSelect}
    onOptionsLoaded={onOptionsLoaded}
    groupBy={option => option.month}
    url={`${Endpoints.FeeAgreementDashboardWeeks}?year=${year?.date ? year.date : ''}`}
    disableClearable
  />
);

const FeeAgreementsBoard = () => {
  const [week, setWeek] = useState(null);
  const [year, setYear] = useState(null);
  const [viewType, setViewType] = useState({
    value: { title: TYPE_TITLE.Weekly },
    isYear: false
  });

  useEffect(() => {
    document.title = PageTitles.DashboardFeeAgreementsBoard;
  }, []);

  const handleSelectForView = (event, newValue) => {
    const isYear = newValue.title === TYPE_TITLE.Yearly;
    setViewType({
      value: newValue,
      isYear
    });

    isYear && setYear(null);

    if (newValue.title === TYPE_TITLE.Weekly) {
      setWeek(null);
      setYear(null);
    }
  };

  const handleSelectForYear = (event, newValue) => {
    setYear(newValue);
  };

  const handleSelectForWeek = (event, newValue) => {
    setWeek(newValue);
    setYear(null);
  };

  const onOptionsLoadedForYear = useCallback(items => {
    setYear(items[defaultElementIndex]);
  }, []);

  const onOptionsLoadedForWeek = useCallback(items => {
    setWeek(items[defaultElementIndex]);
  }, []);

  const AutocompleteViewFilters = (
    <>
      <Grid item xs={5}>
        <AutocompleteForView viewType={viewType} onSelect={handleSelectForView} />
      </Grid>
      <Grid item xs={7}>
        {viewType.isYear ? (
          <AutocompleteByYear
            year={year}
            onSelect={handleSelectForYear}
            onOptionsLoaded={onOptionsLoadedForYear}
          />
        ) : (
          <AutocompleteByWeek
            week={week}
            year={year}
            onSelect={handleSelectForWeek}
            onOptionsLoaded={onOptionsLoadedForWeek}
          />
        )}
      </Grid>
    </>
  );

  return (
    <ContentPageLayout
      text={`Fee Agreements ${viewType.isYear ? 'Yearly' : 'Weekly'} Board`}
      titleLabelProps={backNavigateListConfig}
      customTitleGridConfig={{
        xs: 12,
        sm: 7,
        lg: 7
      }}
      actionsBarConfig={{
        xs: 12,
        sm: 5,
        lg: 5,
        spacing: 2
      }}
      actionsBar={AutocompleteViewFilters}
    >
      <FeeAgreementsLoader endpoint={Endpoints.FeeAgreementDashboard} week={week} year={year} />
    </ContentPageLayout>
  );
};

export default FeeAgreementsBoard;
